module.exports = __webpack_public_path__ + "3e0cf399f72f13c316b02d3ded5c74e1.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/left_hand/smoothie.png
// module id = 3050
// module chunks = 0